import authReducer from "./authReducer";
import machineReducer from "./machineReducer";
import { combineReducers } from "redux";
import { firestoreReducer } from 'redux-firestore';
import {firebaseReducer} from 'react-redux-firebase';

const rootReducer = combineReducers(
  {
    auth: authReducer,
    machine: machineReducer,
    firestore: firestoreReducer,
    firebase: firebaseReducer
  });
export default rootReducer;
